import logoUrl from '../../assets/images/Senerfi-formato.png';

export async function printPersonCV(person = {}, selectedCertificates = null) {
  try {
    // Si el llamador pasa una lista puntual (checkboxes marcados en la UI),
    // se usa esa; si no, se cae al arreglo legacy completo de adjuntos.
    const certList = Array.isArray(selectedCertificates)
      ? selectedCertificates
      : (Array.isArray(person.attachments) ? person.attachments : []);
    const resolvedLogo = new URL(logoUrl, window.location.origin).toString();
    let logoSrc = resolvedLogo;
    try {
      const resp = await fetch(resolvedLogo, { cache: 'no-store' });
      if (resp.ok) {
        const blob = await resp.blob();
        logoSrc = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      }
    } catch (e) {}

    const frame = document.createElement('iframe');
    frame.style.position = 'fixed';
    frame.style.right = '0';
    frame.style.bottom = '0';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    frame.name = 'PRINT_PERSON_CV';
    document.body.appendChild(frame);
    const w = frame.contentWindow;

    const safe = (v) => (v == null ? '' : String(v));
    const today = new Date().toLocaleString('es-CO');

    const parseBirthDate = (value) => {
      if (!value) return null;
      let d = new Date(value);
      if (!isNaN(d)) return d;
      const m1 = String(value).match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{2,4})$/);
      if (m1) {
        const day = parseInt(m1[1], 10);
        const month = parseInt(m1[2], 10) - 1;
        const year = parseInt(m1[3], 10);
        d = new Date(year, month, day);
        if (!isNaN(d)) return d;
      }
      const m2 = String(value).toLowerCase().match(/^(\d{1,2})\s+de\s+([a-zñ]+)(?:\s+de\s+(\d{2,4}))?$/i);
      if (m2) {
        const months = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
        const day = parseInt(m2[1], 10);
        const monthIdx = months.indexOf(m2[2]);
        const year = m2[3] ? parseInt(m2[3], 10) : new Date().getFullYear();
        if (monthIdx >= 0) {
          d = new Date(year, monthIdx, day);
          if (!isNaN(d)) return d;
        }
      }
      return null;
    };

    const computeAge = (value) => {
      const d = parseBirthDate(value);
      if (!d) return '';
      const now = new Date();
      let age = now.getFullYear() - d.getFullYear();
      const m = now.getMonth() - d.getMonth();
      if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age--;
      return age >= 0 ? age : '';
    };

    const signatureImg = person.signature ? `<img src="${person.signature}" alt="Firma" style="max-height:48px; max-width:100%; object-fit:contain" />` : '<div style="height:48px; border-bottom:1px solid #000"></div>';
    const photoImg = person.photo ? `<img src="${person.photo}" alt="Foto" style="width:100%; height:140px; object-fit:cover; border:1px solid #000" />` : '<div style="width:100%; height:140px; border:1px solid #000; display:flex; align-items:center; justify-content:center; font-size:10px; color:#666">Sin foto</div>';
    const ageText = computeAge(person.birthDate) || '';
    const otrosiJoined = Array.isArray(person.otrosiDates)
      ? person.otrosiDates.filter(Boolean).join('\n')
      : (person.otrosiDate || '');

    // QR de verificación con datos básicos
    const qrPayload = encodeURIComponent(JSON.stringify({ id: person.id, name: person.name, position: person.position, phone: person.phone, area: person.area }));
    const qrResolvedUrl = `https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${qrPayload}`;
    let qrSrc = qrResolvedUrl;
    try {
      const resp = await fetch(qrResolvedUrl, { cache: 'no-store' });
      if (resp.ok) {
        const blob = await resp.blob();
        qrSrc = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      }
    } catch (e) {}
    
    // Días hacia próximo EMO (informativo, sin estilos llamativos)
    const daysTo = (() => {
      if (!person.nextEmoDate) return '';
      const d = new Date(person.nextEmoDate);
      if (isNaN(d)) return '';
      const ms = d.setHours(0,0,0,0) - new Date().setHours(0,0,0,0);
      const days = Math.round(ms / 86400000);
      return isFinite(days) ? days : '';
    })();

    w.document.write(`<!doctype html><html><head><meta charset="utf-8" />
      <title>Hoja de Vida</title>
      <style>
        @page { size: 210mm 297mm; margin: 12mm; }
        @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
        body{font-family: Arial, sans-serif; color:#000;}
        .sheet{width: 100%; max-width: 19cm; margin: 0 auto; display:flex; flex-direction:column;}
        table{width:100%; border-collapse:collapse; table-layout: fixed;}
        td, th{border:1px solid #000; padding:6px 8px; font-size:11px; vertical-align:top}
        .no-border td, .no-border th{border:none}
        .header-title{font-weight:700; font-size:14px}
        .section-title{font-weight:600; background:#f7f7f7; border:1px solid #000; padding:6px 8px}
        .center{text-align:center}
        .logo{height:56px; max-width:100%; object-fit:contain; display:block; margin:0 auto}
      </style>
    </head><body>
      <div class="sheet">
        <table>
          <tr>
            <td style="width:30%; text-align:center; vertical-align:middle">
              <img src="${logoSrc}" alt="Senerfi" class="logo" />
            </td>
            <td class="center" style="width:70%">
              <div class="header-title">SOLUCIONES ENERGETICAS FORESTALES INTEGRALES</div>
              <div>HOJA DE VIDA DEL COLABORADOR</div>
            </td>
          </tr>
        </table>

        <table class="no-border" style="margin-top:8px">
          <tr>
            <td class="no-border" style="border:none; text-align:right; font-size:11px">Fecha generación: ${today}</td>
          </tr>
        </table>

        <!-- Resumen con foto -->
        <table style="margin-top:8px">
          <tr><td class="section-title" colspan="4">Resumen</td></tr>
          <tr>
            <td rowspan="4" colspan="1" style="width:30%; vertical-align:top">${photoImg}</td>
            <td style="width:20%"><strong>Nombre</strong></td>
            <td colspan="2" style="width:50%">${safe(person.name)}</td>
          </tr>
          <tr>
            <td><strong>Documento</strong></td>
            <td>${safe(person.id)}</td>
            <td><strong>Estado</strong></td>
            <td>${safe(person.status)}</td>
          </tr>
          <tr>
            <td><strong>Cargo-Rol</strong></td>
            <td>${safe(person.position)}</td>
            <td><strong>Proyecto</strong></td>
            <td>${safe(person.area)}</td>
          </tr>
          <tr>
            <td><strong>Validación Cliente</strong></td>
            <td colspan="2">${safe(person.clientValidation)}</td>
            <td></td>
          </tr>
        </table>

        <!-- Datos personales -->
        <table style="margin-top:8px">
          <tr><td class="section-title" colspan="4">Datos personales</td></tr>
          <tr>
            <td style="width:25%"><strong>Fecha de nacimiento</strong></td>
            <td style="width:25%">${safe(person.birthDate)}</td>
            <td style="width:25%"><strong>Años</strong></td>
            <td style="width:25%">${safe(ageText)}</td>
          </tr>
          <tr>
            <td><strong>Tipo de sangre</strong></td>
            <td>${safe(person.bloodType)}</td>
            <td><strong>Fecha de ingreso</strong></td>
            <td>${safe(person.hireDate)}</td>
          </tr>
          <tr>
            <td><strong>Dirección</strong></td>
            <td colspan="3">${safe(person.address)}</td>
          </tr>
        </table>

        <!-- Contacto -->
        <table style="margin-top:8px">
          <tr><td class="section-title" colspan="4">Contacto</td></tr>
          <tr>
            <td style="width:25%"><strong>Teléfono</strong></td>
            <td style="width:25%">${safe(person.phone)}</td>
            <td style="width:25%"><strong>Email</strong></td>
            <td style="width:25%">${safe(person.email)}</td>
          </tr>
          <tr>
            <td style="width:25%"><strong>Estado civil</strong></td>
            <td style="width:25%">${safe(person.civilStatus)}</td>
            <td style="width:25%"></td>
            <td style="width:25%"></td>
          </tr>
        </table>

        <!-- Seguridad social -->
        <table style="margin-top:8px">
          <tr><td class="section-title" colspan="4">Seguridad social</td></tr>
          <tr>
            <td style="width:25%"><strong>EPS</strong></td>
            <td style="width:25%">${safe(person.eps)}</td>
            <td style="width:25%"><strong>Fondo de Pensiones</strong></td>
            <td style="width:25%">${safe(person.pensionFund)}</td>
          </tr>
          <tr>
            <td><strong>AFP</strong></td>
            <td>${safe(person.afp)}</td>
            <td><strong>Riesgo ARL %</strong></td>
            <td>${safe(person.arlRiskPercent)}</td>
          </tr>
        </table>

        <!-- Contrato -->
        <table style="margin-top:8px">
          <tr><td class="section-title" colspan="4">Contrato</td></tr>
          <tr>
            <td style="width:25%"><strong>Fecha contrato</strong></td>
            <td style="width:25%">${safe(person.contractDate)}</td>
            <td style="width:25%"><strong>Número de contrato</strong></td>
            <td style="width:25%">${safe(person.contractNumber)}</td>
          </tr>
          <tr>
            <td><strong>Modalidad contrato actual</strong></td>
            <td>${safe(person.currentContractModality)}</td>
            <td><strong>Fecha otrosí</strong></td>
            <td style="white-space:pre-line">${safe(otrosiJoined)}</td>
          </tr>
        </table>

        <!-- Salud ocupacional -->
        <table style="margin-top:8px">
          <tr><td class="section-title" colspan="4">Salud ocupacional</td></tr>
          <tr>
            <td style="width:25%"><strong>EMO</strong></td>
            <td style="width:25%">${safe(person.emoDate)}</td>
            <td style="width:25%"><strong>Próximo EMO</strong></td>
            <td style="width:25%">${safe(person.nextEmoDate)}${(() => {
              if (daysTo === '') return '';
              const style = daysTo < 0 ? 'color:#a00; font-weight:700' : (daysTo <= 30 ? 'color:#a60; font-weight:700' : 'color:#0a0;');
              const text = daysTo < 0 ? `Vencido ${Math.abs(daysTo)}d` : (daysTo <= 30 ? `Próximo ${daysTo}d` : `En ${daysTo}d`);
              return ` <span style="${style}">(${text})</span>`;
            })()}</td>
          </tr>
        </table>

        <!-- Formación -->
        <table style="margin-top:8px">
          <tr><td class="section-title" colspan="4">Formación</td></tr>
          <tr>
            <td colspan="4" style="white-space:pre-line">${safe((person.education || ''))}</td>
          </tr>
        </table>

        <!-- Experiencia laboral -->
        <table style="margin-top:8px">
          <tr><td class="section-title" colspan="4">Experiencia laboral</td></tr>
          ${Array.isArray(person.workExperience) && person.workExperience.length > 0
            ? `<tr>
                <td style="width:35%"><strong>Empresa</strong></td>
                <td style="width:30%"><strong>Cargo</strong></td>
                <td style="width:35%" colspan="2"><strong>Periodo</strong></td>
              </tr>
              ${person.workExperience.map((w) => `<tr>
                <td>${safe(w?.company)}</td>
                <td>${safe(w?.position)}</td>
                <td colspan="2">${safe(w?.startDate) || '¿?'} a ${safe(w?.endDate) || 'Actual'}</td>
              </tr>`).join('')}`
            : `<tr><td colspan="4">Sin experiencia laboral registrada</td></tr>`}
        </table>

        <!-- Firma, Adjuntos y QR -->
        <table style="margin-top:8px">
          <tr>
            <td class="section-title" colspan="2">Firma</td>
            <td class="section-title" colspan="1">Certificados y adjuntos</td>
            <td class="section-title" colspan="1">Código QR</td>
          </tr>
          <tr>
            <td colspan="2">${signatureImg}</td>
            <td>${safe(certList.length ? certList.map(a => a?.name || '').filter(Boolean).join(', ') : 'N/A')}</td>
            <td class="center"><img src="${qrSrc}" alt="QR" style="width:120px; height:120px; object-fit:contain; border:1px solid #000;" /></td>
          </tr>
        </table>
      </div>
      <script>
        window.addEventListener('load', function() {
          const img = document.querySelector('.logo');
          const fallbackSrc = window.location.origin + '/Senerfi-formato.png';
          const printNow = () => { window.focus(); window.print(); setTimeout(() => window.close(), 300); };
          if (!img) { printNow(); return; }
          if (img.complete && img.naturalWidth > 0) { printNow(); return; }
          img.addEventListener('load', printNow, { once: true });
          img.addEventListener('error', function onErr() {
            if (img.src !== fallbackSrc) {
              img.src = fallbackSrc;
              img.addEventListener('load', printNow, { once: true });
              img.addEventListener('error', printNow, { once: true });
            } else { printNow(); }
          }, { once: true });
          setTimeout(() => { if (img.complete && img.naturalWidth > 0) { printNow(); } }, 1200);
        });
      </script>
    </body></html>`);
    w.document.close();
    w.focus();
    frame.onload = () => {
      setTimeout(() => { try { document.body.removeChild(frame); } catch (e) {} }, 1500);
    };
  } catch (e) {
    console.error('Error printing person CV', e);
    alert('No se pudo generar la hoja de vida.');
  }
}
